/* eslint-disable no-unused-vars*/
import React, { useCallback, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Col, Form, Input, Row, Switch, Skeleton, Select } from 'antd';
import { ArrowLeftOutlined, SaveOutlined } from '@ant-design/icons';
import { postCreateVideoTutorial, getVideoTutorialById, putUpdateVideoTutorial } from 'api/videoTutorial';
import { getCookie } from 'helper/cookie';
import Swal from 'sweetalert2';
import { get } from 'lodash';
import { messageRequireIcon } from 'common/messageError/message.common';
// import { getAwardTypeFormatAll } from 'api/awardTypeFormat';
// import dayjs from 'dayjs';
// import moment from 'moment';
import { getCategoryTutorialAll } from 'api/categoryTutorial';
const { Option } = Select;
import { Editor } from '@tinymce/tinymce-react';
// import DOMPurify from 'dompurify';
import { VITE_REACT_TINY_API_KEY_2 } from 'src/private/config';

interface propType {
  id: number;
}

const CreateVideoTutorial = (props: propType) => {
  const { id } = props;
  const isMobileView = useSelector(state => get(state, 'device.isMobileView', false));
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const token = getCookie('access_tokenltl');
  const [data, setData] = useState<any>('');
  const [isLoading, setIsLoading] = useState(false);
  const [checkDefault, setCheckDefault] = useState(true);
  const [dataCategoryTutorial, setDataCategoryTutorial] = useState<any>([]);
  const [isLoadingCategoryTutorial, setLoadingCategoryTutorial] = useState(false);
  const [dataTextEditor, setDataTextEditor] = useState('');

  const handleEditorChange = (content: any, editor: any) => {
    setDataTextEditor(content);
  };

  const fetchVideoTutorialById = useCallback(
    async (query: any) => {
      setIsLoading(true);
      const params = {
        id: id,
      };

      try {
        const responseData = await getVideoTutorialById({ token, params: params });
        if (responseData?.status === 200) {
          const { data } = responseData;
          setData(data?.data);
          setIsLoading(false);
          form.setFieldsValue({
            category_tutorial_id: Number(data?.data?.category_tutorial_id),
            video_tutorial_sort: data?.data?.video_tutorial_sort,
            video_tutorial_name: data?.data?.video_tutorial_name,
            video_tutorial_status: data?.data?.video_tutorial_status === 'Y',
          });
          const sanitizedHTML = data?.data?.video_tutorial_detail; //DOMPurify.sanitize(data?.data?.video_tutorial_detail);
          setDataTextEditor(sanitizedHTML);
          setCheckDefault(data?.data?.video_tutorial_status === 'Y');
        } else {
          setData('');
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
      }
    },
    [token, id, form],
  );

  const fetchCategoryTutorialList = useCallback(
    async (query?: any) => {
      setLoadingCategoryTutorial(false);
      const params = {};
      try {
        const responseData = await getCategoryTutorialAll({ token, params: params });
        if (responseData?.status === 200) {
          const { data } = responseData;
          setDataCategoryTutorial(data?.data?.category_tutorial);
          setLoadingCategoryTutorial(false);
        } else {
          setDataCategoryTutorial([]);
          setLoadingCategoryTutorial(false);
        }
      } catch (error) {
        setLoadingCategoryTutorial(false);
      }
    },
    [token, id],
  );

  useMemo(() => {
    if (id && token) {
      fetchVideoTutorialById(id);
    }
  }, [id]);

  useMemo(() => {
    if (token) {
      fetchCategoryTutorialList();
    }
  }, [id, token]);

  const handleSubmit = async (values: any) => {
    // const dateTime = dayjs(values.lottery_end_time);
    // console.log(dateTime.format('HH:mm:ss'))
    // console.log(moment(values.lottery_end_time).format('HH:mm:ss'))
    // console.log(dayjs(values.lottery_end_time, 'HH:mm:ss'))
    const params = {
      category_tutorial_id: Number(values?.category_tutorial_id),
      video_tutorial_sort: values?.video_tutorial_sort,
      video_tutorial_name: values?.video_tutorial_name,
      video_tutorial_status: values?.video_tutorial_status === true ? 'Y' : 'N', // แปลง Boolean เป็น 'Y' หรือ 'N'
      video_tutorial_detail: dataTextEditor, //DOMPurify.sanitize(dataTextEditor)
    };
    if (id) {
      const updateData = await putUpdateVideoTutorial({ token, params: params, id: id });
      if (updateData.status === 200) {
        Swal.fire({
          icon: 'success',
          title: 'อัปเดตข้อมูลสำเร็จ',
          showConfirmButton: false,
          timer: 5000,
        });
        navigate(`/backoffice/video_tutorial`, { replace: true });
        // await fetchVideoTutorialById(id);
      } else {
        Swal.fire({
          icon: 'error',
          title: 'อัปเดตข้อมูลไม่สำเร็จ',
          showConfirmButton: false,
          timer: 5000,
        });
      }
    } else {
      const createData = await postCreateVideoTutorial({ token, params: params });
      if (createData.status === 200) {
        Swal.fire({
          icon: 'success',
          title: 'บันทึกข้อมูลสำเร็จ',
          showConfirmButton: false,
          timer: 5000,
        });
        navigate(`/backoffice/video_tutorial`, { replace: true });
        // await fetchVideoTutorialById(id);
        // navigate(`/backoffice/video_tutorial/edit/${createData?.data?.data?.id}`, { replace: true });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'บันทึกข้อมูลไม่สำเร็จ',
          showConfirmButton: false,
          timer: 5000,
        });
      }
    }
  };

  const renderOpionCategory = () => {
    if (isLoadingCategoryTutorial === false) {
      return dataCategoryTutorial?.map((value: any, index: number) => {
        return (
          <Option value={value.id} key={index}>
            {value.category_tutorial_name}
          </Option>
        );
      });
    }
    return [];
  };

  return (
    <>
      {isLoading === false ? (
        <Form layout="vertical" autoComplete="off" onFinish={handleSubmit} form={form} initialValues={{}}>
          <Row gutter={16} justify="space-between">
            <Col span={isMobileView ? 24 : 12}>
              <Form.Item
                name="category_tutorial_id"
                label="หมวดหมู่วีดีโอ"
                rules={[
                  {
                    required: true,
                    message: messageRequireIcon('กรุณาเลือกข้อมูล หมวดหมู่วีดีโอ'),
                  },
                ]}
              >
                <Select
                  placeholder="กรุณาเลือก หมวดหมู่วีดีโอ"
                  // onChange={(e, option: any) => setGroupUser(option?.children)}
                >
                  {renderOpionCategory()}
                </Select>
              </Form.Item>
            </Col>
            <Col span={isMobileView ? 24 : 12}>
              <Form.Item
                name="video_tutorial_sort"
                label="ลำดับ"
                rules={[
                  {
                    required: true,
                    message: messageRequireIcon('กรุณากรอกข้อมูล ลำดับ'),
                  },
                ]}
              >
                <Input type="text" placeholder="ลำดับ" />
              </Form.Item>
            </Col>
            <Col span={isMobileView ? 24 : 24}>
              <Form.Item
                name="video_tutorial_name"
                label="ชื่อหัวข้อ"
                rules={[
                  {
                    required: true,
                    message: messageRequireIcon('กรุณากรอกข้อมูล ชื่อหัวข้อ'),
                  },
                ]}
              >
                <Input type="text" placeholder="ชื่อหัวข้อ" />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Editor
                id="text-editor"
                apiKey={VITE_REACT_TINY_API_KEY_2}
                init={{
                  height: 600,
                  menubar: false,
                  plugins: [
                    'advlist',
                    'code',
                    'autolink',
                    'lists',
                    'link',
                    'image',
                    'preview',
                    'visualblocks',
                    'table',
                    'media',
                    'advimage',
                    'media link',
                    // 'editimage',
                    // 'advcode'
                  ],
                  toolbar: [
                    'undo redo | fontfamily fontsize | bold italic underline strikethrough formatselect backcolor | forecolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | preview code sample | table | media link | image',
                  ],
                  //  plugins: 'media link table image advimage',
                  //   plugins: [
                  //    'medmedia link anchor autolink charmap codesample'
                  //   ],
                  //   plugins: 'media link anchor autolink charmap codesample emoticons image lists searchreplace table visualblocks wordcount checklist mediaembed casechange export formatpainter pageembed linkchecker a11ychecker tinymcespellchecker permanentpen powerpaste advtable advcode editimage advtemplate ai mentions tinycomments tableofcontents footnotes mergetags autocorrect typography inlinecss',
                  media_live_embeds: true,
                  // toolbar: [
                  // 'undo redo | fontfamily fontsize | bold italic underline strikethrough formatselect  backcolor | forecolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | preview code sample | table |SmartCRValue | DatabaseRequestValue'
                  // ],
                  // plugins: 'anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount checklist mediaembed casechange export formatpainter pageembed linkchecker a11ychecker tinymcespellchecker permanentpen powerpaste advtable advcode editimage advtemplate ai mentions tinycomments tableofcontents footnotes mergetags autocorrect typography inlinecss',
                  // toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat',
                  tinycomments_mode: 'embedded',
                  tinycomments_author: 'Author name',
                  mergetags_list: [
                    { value: 'First.Name', title: 'First Name' },
                    { value: 'Email', title: 'Email' },
                  ],
                  ai_request: (request: any, respondWith: any) => respondWith.string(() => Promise.reject('See docs to implement AI Assistant')),
                }}
                // onChange={(e) => onChangeValueEditor(e)}
                // initialValue={dataTextEditor}
                onEditorChange={handleEditorChange}
                value={dataTextEditor}
                // onKeyUp={(e) => onChangeValueEditor(e)}
                // initialValue="Welcome to TinyMCE!"
              />
            </Col>
            <Col span={isMobileView ? 24 : 12}>
              <Form.Item
                name="video_tutorial_status"
                label="สถานะการใช้งาน"
                rules={[
                  {
                    required: false,
                    message: messageRequireIcon('กรุณากรอกข้อมูล สถานะการใช้งาน'),
                  },
                ]}
                initialValue={checkDefault}
              >
                <Switch checkedChildren={'ใช้งาน'} unCheckedChildren={'ไม่ใช้งาน'} defaultChecked={!id ? true : checkDefault} />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Link to="/backoffice/video_tutorial">
                <Button type="text" htmlType="button" size="large" className="btn btn-md btn-secondary">
                  <ArrowLeftOutlined /> ย้อนกลับ
                </Button>
              </Link>
            </Col>
            <Col span={12}>
              <Button type="primary" htmlType="submit" size="large" className="btn btn-md" style={{ float: 'right' }}>
                <SaveOutlined /> {id ? 'อัปเดตข้อมูล' : `เพิ่มข้อมูล`}
              </Button>
            </Col>
          </Row>
        </Form>
      ) : (
        <Skeleton active />
      )}
    </>
  );
};

export default CreateVideoTutorial;
